import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AgreementFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M18.5 6.25H21.5C22.0523 6.25 22.5 6.69772 22.5 7.25V13.25C22.5 13.8023 22.0523 14.25 21.5 14.25H19.913C19.8988 13.906 19.7611 13.5662 19.5 13.3036L13.5 7.26785H12.5L11.2658 8.50942C10.5452 9.23432 9.39796 9.29823 8.60218 8.65782L7.5 7.77083L10.1213 5.13391C10.6839 4.56795 11.447 4.25 12.2426 4.25H14.5917C15.1839 4.25 15.763 4.42636 16.2558 4.75685L18.5 6.25Z"
				fill="currentColor"
			/>
			<path
				d="M2.5 7.25H6.36368C6.27993 7.43273 6.24055 7.63497 6.25192 7.84C6.27152 8.19373 6.44031 8.52253 6.71631 8.74465L7.81849 9.63164C9.11317 10.6736 10.9811 10.5688 12.1523 9.39068L12.8842 8.65437L18.5 14.3036C18.7611 14.5662 18.8988 14.906 18.913 15.25C18.9289 15.6337 18.7912 16.0225 18.5 16.3155C17.9477 16.871 17.0523 16.871 16.5 16.3155L16 15.8125C16.5523 16.3681 16.5523 17.2688 16 17.8244C15.4477 18.38 14.5523 18.38 14 17.8244L13 16.8184C13.5523 17.374 13.5523 18.2748 13 18.8303C12.4477 19.3859 11.5523 19.3859 11 18.8303L9.5 17.3214C10.0523 17.877 10.0523 18.7778 9.5 19.3333C8.94772 19.8889 8.05229 19.8889 7.5 19.3333L3.5 15.25H2.5C1.94772 15.25 1.5 14.8023 1.5 14.25V8.25C1.5 7.69772 1.94771 7.25 2.5 7.25Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AgreementFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AgreementFilledIcon;
